import { z } from 'zod';
import {
    type ControlSocketKind,
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';

export const tcpConnectionCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('tcpConnection'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
    })),
}));
interface TcpConnectionCfgSchema extends z.infer<typeof tcpConnectionCfgSchema> {}

export const tcpConnectionSocketCfg = {
    controlSockets: {
        outputs: () => {
            const ret: Record<'messageReceieved', ControlSocketKind> = {
                messageReceieved: 'event',
            };
            return ret;
        },
        inputs: () => {
            const ret: Record<'sendMessage', ControlSocketKind> = {
                sendMessage: 'event',
            };
            return ret;
        },
    },
    dataSockets: {
        outputs: () => {
            const ret: {
                receivedMessage: 'string';
            } = {
                receivedMessage: 'string',
            };
            return ret;
        },
        inputs: () => {
            const ret: {
                messageToSend: 'string';
            } = {
                messageToSend: 'string',
            };
            return ret;
        },
    },
} satisfies NodeSocketCfg<TcpConnectionCfgSchema>;
